<template>
  <div class="container">
    <div class="text-center wizard-header-text">
      <h1>Personalized Learning Goal Wizard</h1>
      <p class="gb-text-2">Use the wizard to discover targeted learning goals, objectives, and progress monitoring resources for an individual student.</p>
    </div>
    <WizardOverlayContainer :activated="wizardFocus" @unfocus="unfocus">
      <span
        @click="unfocus"
        v-if="wizardFocus"
        @keypress.enter="unfocus"
        tabindex="0"
        role="button"
        class="close-button"
        aria-label="close goal wizard pop-up"
      >
        <i class="fa fa-close fa-2x"/>
      </span>
      <transition name="fade">
        <router-view/>
      </transition>
      <p class="text-right skip-button">
        <router-link
          :to="{name: 'BrowseGoalsPage'}"
          v-if="!wizardFocus">Skip the wizard</router-link>
      </p>
    </WizardOverlayContainer>
    <SubmitFeedback
      type="Browse Goals Wizard"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import SubmitFeedback from '@/components/SubmitFeedback'
import WizardOverlayContainer from '@/components/WizardOverlayContainer'

export default {
  name: 'BrowseGoalsWizard',
  components: {
    WizardOverlayContainer,
    SubmitFeedback
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      wizardFocus: state => state.browse.wizardFocus
    }),
  },
  methods: {
    unfocus() {
      this.$store.commit('browse/setWizardFocus', false)
      // Only reroute if we have existing params
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.replace({
          name: 'BrowseGoalsWizardModal'
        })
      }
    }
  },
  mounted() {
    this.$sendEvent('Viewed Goal Wizard', {
      ref: this.$route.query.ref
    })
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.fade-enter-active {
  transition-property: opacity;
  transition-duration: 0.5s;
}
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.2s;
}
.fade-enter-active {
  transition-delay: 0.25s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.skip-button {
  margin-top: 24px;
  margin-bottom: 24px;
  a {
    cursor: pointer;
    color: darken(@link-color, 5%); //for accessibility color contrast
  }
}
.wizard-header-text {
  margin-bottom: 60px;
}
</style>
